var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"btn btn-primary",attrs:{"to":_vm.to}},[_vm._t("default",function(){return [(_vm.icon)?_c('i',{staticClass:"mr-3",class:_vm.icon}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }